import { MantineThemeComponents } from '@mantine/core';

export const mantineComponents: MantineThemeComponents = {
	Button: {
		defaultProps: {
			radius: 'lg',
		},
	},
	InputBase: {
		defaultProps: {
			radius: 'lg',
		},
	},
	Input: {
		defaultProps: {
			radius: 'lg',
		},
	},
	Select: {
		defaultProps: {
			radius: 'lg',
		},
	},
	MultiSelect: {
		defaultProps: {
			radius: 'lg',
		},
	},
	Switch: {
		defaultProps: {
			radius: 'lg',
		},
		styles: () => ({
			input: {
				background: '#F0F1F3',
			},
			thumb: {
				border: 'none',
			},
			track: {
				height: 28,
				width: 56,
			},
		}),
	},
	Loader: {
		defaultProps: {
			color: '#FF4405',
		},
	},
	LoadingOverlay: {
		defaultProps: {
			color: '#FF4405',
		},
	},
	Accordion: {
		styles: () => ({
			item: {
				border: 0,
			},
			control: {
				borderRadius: 10,
				backgroundColor: '#F0F1F3',
				marginBottom: 16,
			},
			content: {
				padding: 0,
				paddingBottom: 16,
			},
			label: {
				padding: 0,
			},
		}),
	},
};
